import React, { useRef, useEffect } from "react";

export default function GameEditInfoBox({
  capsuleImage,
  onCapsuleChange,
  description,
  onDescriptionChange,
  releaseDate,
  onReleaseDateChange,
  comingSoon,
  onComingSoonChange,
  genre,
  onGenreChange,
  tags,
  onTagsChange,
  developer,
  onDeveloperChange,
  publisher,
  onPublisherChange,
  rating,
  onRatingChange,
}) {
  const descRef = useRef(null);

  const handleCapsuleChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    onCapsuleChange(file);
  };

  const handleDescChange = (e) => {
    onDescriptionChange(e.target.value);
    const ta = descRef.current;
    if (ta) {
      ta.style.height = "auto";
      ta.style.height = `${ta.scrollHeight}px`;
    }
  };

  useEffect(() => {
    const ta = descRef.current;
    if (ta) {
      ta.style.height = "auto";
      ta.style.height = `${ta.scrollHeight}px`;
    }
  }, [description]);

  return (
    <div className="bg-neutral-800 p-5 rounded text-white text-sm space-y-4">
      <h3 className="text-lg font-bold">게임 정보 편집</h3>

      {/* 캡슐 이미지 업로드 */}
      <div className="w-full aspect-[16/7] bg-gray-700 rounded overflow-hidden relative">
        {capsuleImage && (
          <img
            src={capsuleImage}
            alt="게임 캡슐 이미지"
            className="w-full h-full object-cover"
          />
        )}
        <input
          type="file"
          accept="image/*"
          onChange={handleCapsuleChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
      </div>

      {/* 설명 */}
      <textarea
        ref={descRef}
        value={description}
        onChange={handleDescChange}
        className="block w-full p-2 rounded bg-[#121212] border border-gray-600 resize-none"
        style={{ minHeight: 80, overflow: "hidden" }}
        placeholder="게임 설명을 입력하세요"
      />

      <div className="space-y-3 mt-4">
        {/* 출시일 */}
        <div className="flex items-center gap-3">
          <label className="w-20 text-sm font-medium">출시일</label>
          <input
            type="text"
            value={releaseDate || ""}
            onChange={(e) => onReleaseDateChange(e.target.value)}
            placeholder="ex) 2025, 2025-06, 2025-06-01"
            className="flex-1 p-2 rounded bg-[#121212] border border-gray-600"
          />
        </div>

        {/* 출시 예정 */}
        <div className="flex items-center gap-2 pl-24">
          <input
            id="comingSoon"
            type="checkbox"
            checked={!!comingSoon}
            onChange={(e) => onComingSoonChange(e.target.checked)}
            className="h-4 w-4 text-blue-500 bg-gray-700 border-gray-600 rounded focus:ring-blue-400"
          />
          <label htmlFor="comingSoon" className="text-sm">
            출시 예정인 게임입니다.
          </label>
        </div>

        {/* 장르 */}
        <div className="flex items-center gap-3">
          <label className="w-20 text-sm font-medium">장르</label>
          <input
            type="text"
            value={genre}
            onChange={(e) => onGenreChange(e.target.value)}
            placeholder="콤마로 구분하여 입력"
            className="flex-1 p-2 rounded bg-[#121212] border border-gray-600"
          />
        </div>

        {/* 태그 */}
        <div className="flex items-center gap-3">
          <label className="w-20 text-sm font-medium">태그</label>
          <input
            type="text"
            value={tags}
            onChange={(e) => onTagsChange(e.target.value)}
            placeholder="콤마로 구분하여 입력 (예: 캐주얼,3D,고양이)"
            className="flex-1 p-2 rounded bg-[#121212] border border-gray-600"
          />
        </div>

        {/* 개발사 */}
        <div className="flex items-center gap-3">
          <label className="w-20 text-sm font-medium">개발사</label>
          <input
            type="text"
            value={developer}
            onChange={(e) => onDeveloperChange(e.target.value)}
            placeholder="개발사를 입력하세요"
            className="flex-1 p-2 rounded bg-[#121212] border border-gray-600"
          />
        </div>

        {/* 배급사 */}
        <div className="flex items-center gap-3">
          <label className="w-20 text-sm font-medium">배급사</label>
          <input
            type="text"
            value={publisher}
            onChange={(e) => onPublisherChange(e.target.value)}
            placeholder="배급사를 입력하세요"
            className="flex-1 p-2 rounded bg-[#121212] border border-gray-600"
          />
        </div>

        {/* 이용등급 */}
        <div className="flex items-center gap-3">
          <label className="w-20 text-sm font-medium">이용등급</label>
          <select
            value={rating}
            onChange={(e) => onRatingChange(e.target.value)}
            className="flex-1 p-2 rounded bg-[#121212] border border-gray-600"
          >
            <option value="">--- 선택 ---</option>
            <option value="전체 이용가">전체 이용가</option>
            <option value="12세 이용가">12세 이용가</option>
            <option value="15세 이용가">15세 이용가</option>
            <option value="청소년 이용불가">청소년 이용불가</option>
          </select>
        </div>
      </div>
    </div>
  );
}
